import React from 'react';
import {render} from 'react-dom';
import {default as configureCartStore} from './store/configureStore';
import FavoritePage from "./containers/FavoriteApp";
import {Provider} from "react-redux";
//import './css/preloader.css';
//import './css/materialize.css';

document.addEventListener("DOMContentLoaded", function(event) {
  const favoriteDetailContainer = document.getElementById('favoritedetail');
  if (favoriteDetailContainer) {
    const favStore = configureCartStore();
    let attrs = favoriteDetailContainer.attributes;
    render(<Provider store={favStore}><FavoritePage attrs={attrs}/></Provider>, favoriteDetailContainer);

  }
});
// enable hot module relaoding for the dev server
if (process.env.NODE_ENV === 'development')
  module.hot.accept();
